// Libarary
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CppPriceListService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }
  public accountName: string;
  // Get Cpp Product List
  public getCPPProductData(filters: any) {
    return this.networkService.postRequest(this.configService.getCPPProductData(), filters);
  }
  // get-cpp-customer-price
  // Export Cpp Price List
  public exportCppPriceList(filters) {
    return this.networkService.postRequest(this.configService.getCPPPriceDataExported(), filters);
  }
  // Get Cpp Price List
  public getPriceListAccount(companyCode) {
    return this.networkService.getRequest(this.configService.getPriceListAccount() + '?companyCode=' + companyCode);
  }

  // email Cpp Price List
  // public emailCppPriceList(filters) {
  //  return this.networkService.postRequest(this.configService.getCPPPriceDataExported(), filters);
  // }
  // Get Cpp Customer Price List
  public getCppCustomerPriceList() {
    return this.networkService.getRequest(this.configService.getCPPCustomerPriceData());
  }

  // To get CPP Filter data
  public getCPPFilterData(accountNo: number) {
    return this.networkService.getRequest(this.configService.getCPPFilterDataUrl() + '?accountNo=' + accountNo);
  }

  // Email Cpp Price List
  public emailCppProductList(filters) {
    return this.networkService.postRequest(this.configService.getCppEmailProductListUrl(), filters);
  }

  // OwnerPriceList Access Permission
  public ownerPriceListAccessPermission(accountNo: number) {
    return this.networkService.getRequest(this.configService.getOwnerPriceListAccessPermissionUrl() + '?accountNo=' + accountNo);
  }

  // add/remove Favorite Items
  public addRemoveItemFavoriteItems(filters) {
    return this.networkService.postRequest(this.configService.addRemoveItemFavorite(), filters);
  }
}
